var colorHelper = {

	// clean hex if it is a number passed
	// accepts for # and 0x
	cleanHex : function(hex){
		if( typeof hex == 'number' ){
  			hex = hex+'';
  		}
  		
	    hex = hex.replace('#','');
	    hex = hex.replace('0x','');
	    
	    return hex;

	},

	// submit rgb string value
	// return array value 1-0
	rgbToUniforms : function(rgb) {
    
	    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	    
	    var factor = 1000;
	    
	    var r = Math.round( parseInt(rgb[1],10) * factor ) / factor;
	    var g = Math.round( parseInt(rgb[2],10) * factor ) / factor;
	    var b = Math.round( parseInt(rgb[3],10) * factor ) / factor;

	    return [ 
	    	Math.round( r / 255 * factor) / factor, 
	    	Math.round( g / 255 * factor) / factor, 
	    	Math.round( b / 255 * factor) / factor, 
	    	1
	    ];
  	},

  	// submit a HEX - 0xFFFFFF or #FFFFFF
	// returns an RGB string return;
  	hexToRgb : function(hex) {

  		hex = this.cleanHex(hex);

	    var r = parseInt(hex.substring(0,2), 16);
	    var g = parseInt(hex.substring(2,4), 16);
	    var b = parseInt(hex.substring(4,6), 16);

	    return 'rgb('+r+','+g+','+b+')';
	},

	// submit a HEX - 0xFFFFFF or #FFFFFF
	// returns an array value between 255 - [155,100,255]
  	hexToRgbArray : function(hex) {

  		hex = this.cleanHex(hex);
  		var factor = 1000;

	    var r = Math.round(parseInt(hex.substring(0,2), 16) * factor) / factor;
	    var g = Math.round(parseInt(hex.substring(2,4), 16) * factor)/factor;
	    var b = Math.round(parseInt(hex.substring(4,6), 16) * factor)/factor;

	    return [r,g,b];
  	},

  	// submit a HEX - 0xFFFFFF or #FFFFFF
	// returns an RGBA array value between 1-0 with alpha - [0.3445,0.5199,0.799,1.0]
  	hexToUniforms : function(hex) {

	    var rgb = this.hexToRgb(hex);

	    return this.rgbToUniforms(rgb);

	}
}

module.exports = colorHelper; 


/** WEBPACK FOOTER **
 ** ./src/js/helpers/colors.js
 **/